/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { LogoSize } from './logo-size'
import { getLogoImageUrl } from './logo-image-url'
import React from 'react'

interface HedgeDocLogoHorizontalGreyProps {
  color: 'dark' | 'light'
  size?: LogoSize | number
  showText?: boolean
  width?: string | number
  className?: string
}

export const HedgeDocLogoHorizontalGrey: React.FC<HedgeDocLogoHorizontalGreyProps> = ({
  color,
  size = LogoSize.MEDIUM,
  showText = true,
  width = 'auto',
  className
}) => {
  return (
    <svg
      clipRule='evenodd'
      fillRule='evenodd'
      height={`${size}px`}
      width={width}
      strokeLinejoin='round'
      strokeMiterlimit='2'
      className={className}
      viewBox={showText ? '0 0 1660.2405 430.07892' : '0 0 430.07892 430.07892'}
      xmlns='http://www.w3.org/2000/svg'>
      <g fillRule='nonzero' transform='translate(10.242436 10.242452)'>
        <image href={getLogoImageUrl(size)} x='-10.242436' y='-10.242452' width='430.07892' height='430.07892' />
        {showText && (
          <text
            x='520'
            y='290'
            fontSize='250'
            fontWeight='600'
            fontFamily='inherit'
            fill={color === 'light' ? '#333' : '#fff'}>
            LeafDoc
          </text>
        )}
      </g>
    </svg>
  )
}
